module.exports = "https://web-assets.ifttt.com/packs/media/fonts/avenir_next-medium-b4965c5b.eot";